/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_NewInputs */

const cs_ebr_diff_new = /** @type {(inputs: Ebr_Diff_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z eBrány`)
};

const en_ebr_diff_new = /** @type {(inputs: Ebr_Diff_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From eBrána`)
};

/**
* | output |
* | --- |
* | "From eBrána" |
*
* @param {Ebr_Diff_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_new = /** @type {((inputs?: Ebr_Diff_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_new(inputs)
	return cs_ebr_diff_new(inputs)
});